<!-- Loading spinner avant le chargement du survey -->
<div *ngIf="loading" class="loading-overlay">
  <div class="spinner-container">
    <div class="spinner"></div>
    <p>Chargement du formulaire...</p>
  </div>
</div>

<div class="form-container" *ngIf="!loading">
  
  <form [formGroup]="satisfactionForm" (ngSubmit)="onSubmit()" *ngIf="!alreadyResponded; else viewMode">
    
    <!-- Header -->
    <div class="header">
      <div class="logo-section">
        <img [src]="logo ? 'data:image/jpg;base64,' + logo : 'assets/img/logo.jpg'" 
             class="img-fluid mr-2 col-xs-12 logo_company">
      </div>
      <div class="title-section">
        <h1>COMMERCIAL</h1>
        <h2>Enquête satisfaction client</h2>
      </div>
      <div class="info-section">
        <div><strong>Référence :</strong> FO-COM-001</div>
        <div><strong>Version :</strong> 1</div>
        <div><strong>Date :</strong> {{currentDate | date : 'dd/MM/yyyy'}}</div>
        <div><strong>Page :</strong> 1/1</div>
      </div>
    </div>

    <!-- Client -->
    <div class="client-section">
      <strong>Client :</strong> {{customerRs}}
    </div>

    <!-- Introduction -->
    <div class="intro-section">
      <p>
        <strong>Cher client :</strong><br />
        Améliorer, c'est d'abord mesurer et analyser, dans ce sens nous vous sollicitons pour évaluer nos
        performances et caractériser nos forces et nos faiblesses; nous avons la volonté d'être toujours plus
        proches de vos attentes et de vos préoccupations.
      </p>
      <p>
        Merci d'avance de bien vouloir remplir ces champs et répondre à ces quelques questions.
      </p>
      <p class="scale-note">
        Utilisez SVP, lors de votre évaluation une échelle de 4 à 1 (4 = Très satisfaisant ; 1 = Insatisfaisant)
      </p>
    </div>

    <!-- Emoji Header -->
    <div class="emoji-header">
      <span>😊</span>
      <span>🙂</span>
      <span>😐</span>
      <span>☹️</span>
    </div>
    
    <!-- Dynamic Questions Section -->
    <div class="form-section" *ngFor="let question of questions; let i = index">
      <div class="section-title" *ngIf="i === 0">1 - Avez-vous des remarques sur nos produits?</div>
      <div class="section-title" *ngIf="i === 1">2- Quelles sont vos remarques liées au service commercial ?</div>
      <div class="section-title" *ngIf="i === 7">4- Quelles sont vos remarques sur le service qualité ?</div>
      <div class="section-title" *ngIf="i === 9">5- Quel est votre degré de satisfaction général en ce qui concerne notre entreprise ?</div>
      <div class="section-title" *ngIf="i === 10">6- Vos suggestions :</div>
      
      <div class="form-row" *ngIf="question.type === 'ch' && i < 9">
        <label>{{question.qst}} <span class="required-field" *ngIf="question.type === 'ch'">*</span></label>
        <div class="checkbox-group">
          <div class="checkbox-item" *ngFor="let val of ['4', '3', '2', '1']">
            <input
              type="radio"
              [name]="'question_' + i"
              [formControlName]="'question_' + i"
              [value]="val"
              (change)="onCheckboxChange(i, val)"
              [disabled]="isSubmitting || loadingSending"
              required
            />
            <span>{{ val }}</span>
          </div>
        </div>
        <div class="error-message" *ngIf="satisfactionForm.get('question_' + i)?.invalid && satisfactionForm.get('question_' + i)?.touched">
          Veuillez sélectionner une réponse
        </div>
      </div>
      
      <!-- Satisfaction générale (question 10) -->
      <div class="satisfaction-section" *ngIf="i === 9">
        <div class="satisfaction-options">
          <div class="satisfaction-option" *ngFor="let option of ['tres-satisfait', 'satisfait', 'insatisfait']; let j = index">
            <input
              type="radio"
              [name]="'question_' + i"
              [formControlName]="'question_' + i"
              [value]="option"
              [disabled]="isSubmitting || loadingSending"
              required
            />
            <label>{{ ['Très satisfait', 'Satisfait', 'Insatisfait'][j] }}</label>
          </div>
        </div>
        <div class="error-message" *ngIf="satisfactionForm.get('question_' + i)?.invalid && satisfactionForm.get('question_' + i)?.touched">
          Veuillez sélectionner votre degré de satisfaction
        </div>
      </div>
      
      <!-- Suggestions (question 11) -->
      <div class="suggestions-section" *ngIf="i === 10">
        <textarea
          [formControlName]="'question_' + i"
          rows="6"
          placeholder="Vos suggestions..."
          [disabled]="isSubmitting || loadingSending"
        ></textarea>
      </div>
    </div>
    
    <!-- Footer -->
    <div class="form-section">
      <div class="footer-section">
        <div>
          <div class="footer-field">
            <label>Questionnaire rempli par : <span class="required-field">*</span></label>
            <input 
              type="text" 
              formControlName="rempliPar" 
              placeholder="................................................"
              [disabled]="isSubmitting || loadingSending"
              required
            />
            <div class="error-message" *ngIf="satisfactionForm.get('rempliPar')?.invalid && satisfactionForm.get('rempliPar')?.touched">
              Ce champ est obligatoire
            </div>
          </div>
          <div class="footer-field">
            <label>Fonction :</label>
            <input 
              type="text" 
              formControlName="fonction" 
              placeholder="................................................"
              [disabled]="isSubmitting || loadingSending"
            />
          </div>
        </div>
        <div>
          <div class="footer-field">
            <label>Date : <span class="required-field">*</span></label>
            <input 
              type="text" 
              formControlName="date" 
              placeholder="................................................"
              [disabled]="isSubmitting || loadingSending"
              required
            />
          </div>
          <div class="footer-field">
            <label>Visa :</label>
            <input 
              type="text" 
              formControlName="visa" 
              placeholder="................................................"
              [disabled]="isSubmitting || loadingSending"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- Boutons d'action -->
    <div class="action-buttons no-print">
      <button 
        type="button" 
        class="submit-button" 
        (click)="onSubmit()"
        [disabled]="isSubmitting || loadingSending || !hasAtLeastOneResponse() || !satisfactionForm.valid"
        [class.disabled]="isSubmitting || loadingSending || !hasAtLeastOneResponse() || !satisfactionForm.valid"
      >
        <span *ngIf="!loadingSending">Soumettre</span>
        <span *ngIf="loadingSending">
          <i class="fas fa-spinner fa-spin"></i> Envoi en cours...
        </span>
      </button>
      <button 
        type="button" 
        class="reset-button" 
        (click)="resetForm()"
        [disabled]="isSubmitting || loadingSending"
      >
        Réinitialiser
      </button>
    </div>
    
    <!-- Message d'information -->
    <div class="info-message" *ngIf="!hasAtLeastOneResponse() && satisfactionForm.touched">
      <i class="fas fa-info-circle"></i>
      Veuillez répondre à au moins une question et remplir le champ "Questionnaire rempli par"
    </div>
  </form>
  
  <ng-template #viewMode>
    <div class="view-mode">
      <div class="success-card">
        <!-- Particules flottantes -->
        <div class="floating-particle"></div>
        <div class="floating-particle"></div>
        <div class="floating-particle"></div>
        <div class="floating-particle"></div>
        
        <div class="success-icon">
          <i class="fas fa-check-circle"></i>
        </div>
        <h3 class="success-title">Merci pour votre participation !</h3>
        <p class="success-message">
          Vos réponses ont été enregistrées avec succès. Nous vous remercions sincèrement 
          d'avoir pris le temps de partager votre avis.
        </p>
            
        <div class="closing-message">
          <p>Votre feedback est précieux pour nous aider à améliorer nos services.</p>
          <p class="thank-you">L'équipe WAMGroup vous remercie.</p>
          
          <!-- Promotion MasterField -->
          <div class="masterfield-promo">
            <div class="promo-divider">
              <span>Propulsé par</span>
            </div>
            <div class="promo-content">
              <img src="../assets/img/suivitim_img/logo_menu.png" alt="MasterField" class="promo-logo">
              <p class="promo-text">
                Cette enquête a été créée avec 
                <strong>MasterField</strong>, l'outil qui maîtrise l'activité 
                de votre équipe commerciale sur le terrain et simplifie 
                votre quotidien.
              </p>
              <a [href]="masterfieldUrl" target="_blank" class="promo-link">
                <i class="fas fa-external-link-alt mr-2"></i>
                Découvrir MasterField
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</div>